// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/common.json';
import it from './locales/it/common.json';
import zh from './locales/zh/common.json';
import ja from './locales/ja/common.json';
import ko from './locales/ko/common.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            it: { translation: it },
            zh: { translation: zh },
            ja: { translation: ja },
            ko: { translation: ko },
        },
        //lng: 'it',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['navigator'],
            caches: []
        }
    });

export default i18n;
